<h4 [class.error]="(wrongSchema$ | async) === true">
  {{'registration.company_kml_upload' | translate}}
  <mat-icon fontIcon="info_outline"
            class="mat-icon-headline"
            matTooltip="{{'registration.company_geojson_file_tooltip' | translate}}"
            matTooltipPosition="right"
  ></mat-icon>
</h4>
<!-- for edit vnb has a delete button -->
<ng-content></ng-content>
<app-file-upload [acceptedFileType]="['geojson']"
                 [maxFileSizeInMb]="5"
                 [deleteFileAgain]="true"
                 [wrongSchemaOnFile]="wrongSchema$ | async"
                 (selectedFile)="onSelectedFile($event)"></app-file-upload>
<span class="error error-text"
      *ngIf="(wrongSchema$ | async) === true">
  {{'registration.company_kml_upload.error_schema' | translate }}
</span>
